import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@src/environments/environment';
import { AppLanguage } from './language.service';

/**
 * Zapis języka konta w profilu. PUT /users/profile przyjmuje częściowe
 * UpdateUserDto, więc wysyłamy samo `preferredLanguage` (backend dopuszcza pl/en).
 */
@Injectable({ providedIn: 'root' })
export class UserLanguageApiService {
  private readonly http = inject(HttpClient);

  updatePreferredLanguage(lang: AppLanguage): Observable<void> {
    return this.http
      .put<unknown>(`${environment.apiUrl}users/profile`, { preferredLanguage: lang })
      .pipe(map(() => undefined));
  }
}
